jQuery(document).ready(function($) {
    // Verificar Fancybox
    if (typeof $.fn.fancybox !== 'undefined') {
        // Inicializa las galerías Masonry
        $('.masonry-fullscreen').each(function(index) {
            var galleryId = 'masonry' + (index + 1);
            var $gallery = $(this);

            // Actualiza los data-fancybox y data-gallery
            $gallery.find('[data-fancybox]').attr('data-fancybox', galleryId);
            $gallery.siblings('.masonry-fullscreen__loader').find('.load-more').attr('data-gallery', galleryId);

            var $grid = $gallery.masonry({
                itemSelector: '.masonry-fullscreen__element',
                columnWidth: '.masonry-fullscreen-sizer',
                percentPosition: true
            });

            // Función para inicializar lazy loading
            function initLazyLoad() {
                var lazyImages = $gallery.find('img.lazy');

                // Configurar el IntersectionObserver
                var observer = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            var $img = $(entry.target);
                            var originalSrc = $img.data('original');
                            if (originalSrc) {
                                $img.attr('src', originalSrc).removeClass('lazy');
                                // Cuando se carga una imagen, forzamos un layout
                                $img.on('load', function() {
                                    $grid.masonry('layout');
                                });
                            }
                            observer.unobserve(entry.target);
                        }
                    });
                }, {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.1
                });

                lazyImages.each(function() {
                    observer.observe(this);
                });
            }

            // Inicializa lazy loading para imágenes
            initLazyLoad();

            // Mostrar los elementos iniciales
            var itemsToShow = 7; // Número de elementos a mostrar inicialmente
            var $items = $gallery.find('.masonry-fullscreen__element');

            // Añadir la clase 'show' a los primeros itemsToShow elementos
            $items.slice(0, itemsToShow).addClass('show');

            // Los elementos ocultos
            var hiddenItems = $items.slice(itemsToShow);

            // Configuración del botón 'Cargar más'
            var $loadMoreButton = $gallery.siblings('.masonry-fullscreen__loader').find('.load-more');
            $loadMoreButton.on('click', function() {
                var $button = $(this);
                var $spinner = $button.siblings('div').find('.spinner'); // Selecciona el spinner

                $spinner.show(); // Mostrar el spinner mientras se cargan las imágenes

                // Simula una llamada de carga de imágenes
                setTimeout(function() {
                    hiddenItems.slice(0, 3).addClass('show'); // Mostrar los siguientes 3 elementos ocultos
                    hiddenItems = hiddenItems.slice(3); // Actualizar los elementos ocultos
                    
                    // Inicializa lazy loading para nuevas imágenes
                    initLazyLoad();

                    // Asegúrate de que Masonry haga el layout después de agregar los elementos
                    $grid.masonry('layout');

                    if (hiddenItems.length === 0) {
                        $button.hide(); // Ocultar el botón si no hay más elementos
                    }

                    $spinner.hide(); // Ocultar el spinner cuando se complete la carga
                }, 1000); // Simula un tiempo de carga de 1 segundo
            });
        });

        // Inicialización de Fancybox para todas las galerías
        $("[data-fancybox]").fancybox({
            thumbs: {
                autoStart: false,
            },
            toolbar: {
                display: [
                    "close",
                ],
            },
        });
    } else {
        console.error("Fancybox is not defined. Please make sure Fancybox is included before this script.");
    }
});